var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
          'donate-entrance':true,
          'mobile':_vm.isMobile
        },attrs:{"data-type":"donate-entrance"},on:{"click":_vm.handleDonate}})
}
var staticRenderFns = []

export { render, staticRenderFns }